
import React from 'react';

const UlosotonVaikutuksetSection: React.FC = () => {
  return (
    <>
      <h2>Ulosoton vaikutukset</h2>
      <p className="mb-6">
        Ulosotto vaikuttaa merkittävästi velallisen elämään. Tässä yleisimmät vaikutukset:
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div>
          <h3 className="text-lg font-semibold mb-2">Taloudelliset vaikutukset</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Käteen jäävien tulojen pieneneminen</li>
            <li>Pankkitilin mahdollinen ulosmittaus</li>
            <li>Omaisuuden realisointi (asunto, auto, arvoesineet)</li>
            <li>Veronpalautusten ulosmittaus</li>
          </ul>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-2">Muut vaikutukset</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Maksuhäiriömerkintä luottotietoihin</li>
            <li>Vaikeudet lainan, vakuutusten ja vuokra-asunnon saamisessa</li>
            <li>Työpaikan saaminen voi vaikeutua tietyillä aloilla</li>
            <li>Henkinen kuormitus ja stressi</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default UlosotonVaikutuksetSection;
